import { useAuth } from "@west-tennessee-consulting/ui";
import { useQuery } from "@tanstack/react-query";
import { logger } from "@/lib/logger";
import { fetchMessage } from "./api-client/index";
import { PROVIDER_MAP } from "./constants";
import { validateMessageSafe } from "@/lib/core/crm/schemas";

/**
 * Hook for fetching a single message
 */
export function useMessage(
  provider: string,
  messageId: string,
  connectionId: string,
  enabled: boolean = true
) {
  const { getAuthToken } = useAuth();
  const token = getAuthToken();
  return useQuery({
    queryKey: ["provider-message", provider, messageId, connectionId],
    queryFn: () => fetchMessage(provider, messageId, connectionId, token || undefined),
    enabled: enabled && Boolean(provider && messageId && connectionId),
    staleTime: 5 * 60 * 1000, // 5 minutes for message details
    refetchOnWindowFocus: false, // Don't refetch on window focus for message details
  });
}

/**
 * Hook for fetching a single message with automatic provider mapping
 */
export function useMessageWithProviderMapping(
  messageId: string,
  connectionId: string,
  provider: string,
  enabled: boolean = true
) {
  const providerKey = PROVIDER_MAP[provider] || provider;

  if (process.env.NODE_ENV === "development") {
    logger.info("🔗 useMessageWithProviderMapping called", {
      messageId,
      connectionId,
      provider,
      providerKey,
      enabled,
    });
  }

  return useMessage(providerKey, messageId, connectionId, enabled);
}
